import { OrderForm } from './orderForm';
import { User } from './user';
import { TaxData } from './taxData';
import { Coupon } from './coupon';
import { Order } from './order';
import { NavParams } from './navParams';
import { OrderDetails } from './orderDetails';
import { ShippingInfo } from './shippingInfo';
import { BumpExpireItem } from './bumpExpireItem';

/**
 * Top-level persisted state stored under the `state` key in Ionic Storage
 * (database `__ghdb`). Every field is optional because state is built up
 * incrementally as the user moves through the funnel — pre-purchase pages
 * only set `navParams`; checkout adds `accountDetails` / `orderDetails` /
 * `taxData`; upsell pages append to `upsells`.
 */
export class State {
  pageName?: string;
  navParams?: NavParams;
  orderDetails?: OrderDetails;
  funnel?: OrderForm;
  coupon?: Coupon;
  date?: number;
  accountDetails?: User;
  taxData?: TaxData;
  bumpExpireList?: BumpExpireItem[];
  upsells?: Order[];
  shippingInfo?: ShippingInfo;
}
